import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import Icon from '../../components/AppIcon';

const SignupPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedPlan = location?.state?.selectedPlan;

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    fullName: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target?.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setError('');

    if (formData?.password !== formData?.confirmPassword) {
      setError('As senhas não coincidem');
      return;
    }

    if (formData?.password?.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres');
      return;
    }

    setLoading(true);

    try {
      const { data, error: signUpError } = await supabase?.auth?.signUp({
        email: formData?.email,
        password: formData?.password,
        options: {
          data: {
            full_name: formData?.fullName,
          },
        },
      });

      if (signUpError) throw signUpError;

      if (data?.user) {
        if (selectedPlan) {
          navigate('/pricing');
        } else {
          navigate('/dashboard-overview');
        }
      }
    } catch (err) {
      setError(err?.message || 'Erro ao criar conta. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <img 
              src="/assets/images/Captura_de_tela_2026-02-06_014642-1770355644537.png" 
              alt="VERTEX COMMERCE Logo" 
              className="w-12 h-12 object-contain"
            />
            <span className="font-bold text-2xl text-gray-900">VERTEX COMMERCE</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Criar Conta</h1>
          <p className="text-gray-600">Comece a vender com estratégia hoje</p>
        </div>

        {/* Form */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          {error && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg flex items-start gap-3">
              <Icon name="AlertCircle" size={20} className="text-red-600 mt-0.5 flex-shrink-0" />
              <p className="text-red-700 text-sm">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Nome Completo"
              type="text"
              name="fullName"
              value={formData?.fullName}
              onChange={handleChange}
              required
              placeholder="Seu nome completo"
            />

            <Input
              label="E-mail"
              type="email"
              name="email"
              value={formData?.email}
              onChange={handleChange}
              required
              placeholder="seu@email.com"
            />

            <Input
              label="Senha"
              type="password"
              name="password"
              value={formData?.password}
              onChange={handleChange}
              required
              placeholder="Mínimo 6 caracteres"
              description="Mínimo 6 caracteres"
            />

            <Input
              label="Confirmar Senha"
              type="password"
              name="confirmPassword"
              value={formData?.confirmPassword}
              onChange={handleChange}
              required
              placeholder="Digite a senha novamente"
            />

            <Button
              type="submit"
              fullWidth
              size="lg"
              loading={loading}
              disabled={loading}
            >
              <Icon name="UserPlus" size={20} />
              Criar Conta
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-gray-600">
              Já tem uma conta?{' '}
              <button
                onClick={() => navigate('/login')}
                className="text-blue-600 font-semibold hover:underline"
              >
                Entrar
              </button>
            </p>
          </div>
        </div>

        {/* Back to Home */}
        <div className="text-center mt-6">
          <button
            onClick={() => navigate('/')}
            className="text-gray-600 hover:text-gray-900 flex items-center gap-2 mx-auto"
          >
            <Icon name="ArrowLeft" size={16} />
            Voltar para início
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupPage;